<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'grade' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ gradeName }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: 'Home', href: '/' },
          {
            text: 'Year of Degree',
            href: '/grades'
          },
          {
            text: 'Show',
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-4"></div>
          <div class="col-lg-4">
            <div class="tree">
              <ul>
                <li>
                  <a href="#">
                    <select v-model="model.year" class="form-control">
                      <option value="">--Select--</option>
                      <option value="YEAR I">YEAR I</option>
                      <option value="YEAR II">YEAR II</option>
                      <option value="YEAR III">YEAR III</option>
                      <option value="YEAR IV">YEAR IV</option>
                    </select>
                  </a>
                  <ul>
                    <li>
                      <a href="#">SEMESTER I</a>
                      <ul v-if="model.subject_list.semester1.subject_id.length">
                        <li>
                          <a href="#" class="text-left">
                            <div
                              v-for="subject in model.subject_list.semester1
                                .subject_id"
                              :key="subject.subject_id"
                            >
                              <span
                                ><i class="far fa-dot-circle"></i>
                                {{ subject.subject_name_foreign }}</span
                              >
                            </div>
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="#">SEMESTER II</a>
                      <ul v-if="model.subject_list.semester2.subject_id.length">
                        <li>
                          <a href="#" class="text-left">
                            <div
                              v-for="subject in model.subject_list.semester2
                                .subject_id"
                              :key="subject.subject_id"
                            >
                              <span
                                ><i class="far fa-dot-circle"></i>
                                {{ subject.subject_name_foreign }}</span
                              >
                            </div>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4"></div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'grade-form',
  data () {
    return {
      model: {
        year: '',
        subject_list: {
          semester1: {
            semester: 'SEMESTER I',
            subject_id: []
          },
          semester2: {
            semester: 'SEMESTER II',
            subject_id: []
          }
        }
      },
      subject_loading: false
    }
  },
  computed: {
    ...mapState('grade', ['edit_data']),
    gradeName () {
      if (this.edit_data === null || this.edit_data === undefined) return

      return this.edit_data.grade_name_foreign
    }
  },
  created () {
    this.setShow()
  },
  methods: {
    setShow () {
      if (this.edit_data === null || this.edit_data === undefined) return
      this.edit_data.grade_subjects.map(subj => {
        this.model.year = subj.years
        if (subj.terms === 'SEMESTER I') {
          this.model.subject_list.semester1.subject_id.push({
            subject_id: subj.subject_id,
            subject_name_foreign: subj.subject_name_foreign
          })
        } else {
          this.model.subject_list.semester2.subject_id.push({
            subject_id: subj.subject_id,
            subject_name_foreign: subj.subject_name_foreign
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.menu-container {
  overflow-x: scroll;
  min-height: 50vh;
  overflow-y: scroll;
  width: 99%;
}
.tree {
  width: max-content;
}

/*Now the CSS*/
.tree ul {
  margin: 0;
  padding: 0;
  padding-top: 20px;
  position: relative;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 10px 0 10px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*We will use ::before and ::after to draw the connectors*/

.tree li::before,
.tree li::after {
  content: '';
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1px solid #ccc;
  width: 50%;
  height: 20px;
}
.tree li::after {
  right: auto;
  left: 50%;
  border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without 
  any siblings*/
.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
  padding-top: 0;
}

/*Remove left connector from first child and 
  right connector from last child*/
.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}
/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
  border-right: 1px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}
.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #ccc;
  width: 0;
  height: 20px;
}

.tree li a {
  border: 1px solid #ccc;
  padding: 8px 10px;
  text-decoration: none;
  color: #666;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
  white-space: normal;
  display: inline-block;

  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover,
.tree li a:hover + ul li a {
  background: #c8e4f8;
  color: #000;
  border: 1px solid #94a0b4;
}
/*Connector styles on hover*/
.tree li a:hover + ul li::after,
.tree li a:hover + ul li::before,
.tree li a:hover + ul::before,
.tree li a:hover + ul ul::before {
  border-color: #94a0b4;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
div::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}
select {
  border: none;
  -webkit-appearance: none;
  appearance: none;
  text-align: center;
  text-align-last: center;
}

option {
  text-align: left;
}

/*Thats all. I hope you enjoyed it.
  Thanks :)*/
</style>
